import { useQuery } from '@tanstack/react-query';
import { getFragmentUrl } from '../actions/actions';

export function useFragmentMediaUrlQuery(fragmentId: string) {
  return useQuery({
    queryKey: ['fragment-url', fragmentId],
    queryFn: () => getFragmentUrl(fragmentId),
    refetchInterval: (query) => {
      const doRefresh = !query.state.status || query.state.status !== 'success';

      return doRefresh ? 10000 : false;
    },
  });
}
